import { StepLayout } from '../StepLayout'
import { resolveButtonLabel } from '../logic/stepState'
import { PrimaryStepButton } from './PrimaryStepButton'
import type { StepProps } from './types'

/** The form's opening and closing word: no answer to give, so it is a brand moment instead. */
export const InfoStep = ({
	step,
	onNext,
	onBack,
	onClose,
	progress,
	isSubmitting,
}: StepProps) => (
	<StepLayout
		title={step.title}
		description={step.description}
		lead="moment"
		progress={progress}
		onBack={onBack}
		onClose={onClose}
		cta={
			<PrimaryStepButton
				label={resolveButtonLabel(step, undefined)}
				onPress={onNext}
				isLoading={isSubmitting}
			/>
		}
	/>
)
